export const SESSION_STORAGE_KEYS = {
  SESSION_ID: 'koalaSessionId',
  SESSION_START: 'koalaSessionStartTime',
  KOALA_ORDER: 'koalaOrder',
  ORDER_START: 'cooOrderStart',
  CHUNK_LOAD_RELOAD_COUNT: 'chunk_load_reload_count',
  /**
   * Cart lines already prompted about a required option the menu no longer satisfies — TEAM-15138.
   * Deliberately its own key rather than a field on `KOALA_ORDER`: the basket slice is rebuilt from
   * that blob on almost every reducer case, so a field living inside it would be wiped on every
   * route change and the prompt would fire again each time.
   */
  OPTION_PROMPTS_SHOWN: 'cooOptionPromptsShown',
};

export const LOCAL_STORAGE_KEYS = {
  /**
   * "Save Cart for Later" on the Toast repeat-failure modal — TEAM-15276. In localStorage rather
   * than beside `KOALA_ORDER` because sessionStorage dies with the tab, which is exactly the case
   * the button exists for. See `utils/savedCart.ts`.
   */
  SAVED_CART: 'cooSavedCart',
};
